import * as React from 'react';

import { Link } from 'react-router-dom';
import {
    Typography
} from '@material-ui/core';

export function Home() {
    return (
        <React.Fragment>
            <Typography variant="h2">Home</Typography>
            <ul>
                <li><Link to="/data-access">Data Access</Link></li>
                <li><Link to="/configuration">Configuration</Link></li>
                {/* <li><Link to="/louver-selection">Louver Selection</Link></li> */}
                {/* <li><Link to="/louver">Louver Workflow</Link></li> */}
                <li><Link to="/louver-xm">Louver Workflow</Link></li>
                <li><Link to="/batch-testing">Batch Testing</Link></li>
                <li><Link to="/grd">GRD Workflow</Link></li>
            </ul>
        </React.Fragment>
    );
}